define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const RestApi       = require("shared/services/RestApi");

    /**
     * Abstract base class for creating integrations.
     *
     * @see CustomFontIntegrationModel
     * @see TypekitIntegrationModel
     * @see FontsDotComIntegrationModel
     * @see AmazonRekognitionIntegrationModel
     *
     * @class IntegrationModel
     */
    return ImprovedModel.extend("IntegrationModel", {

        defaults: {
            companyId: undefined
        },

        url() {
            return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.INTEGRATIONS) : RestApi.pathToSpecificResource(RestApi.Collections.INTEGRATIONS, this.id);
        }

    }, {
        /**
         * The integration type, e.g TypekitIntegration.<p>
         *
         * This static property must be implemented by the subclass.
         *
         * @type {String}
         */
        type: null
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/IntegrationModel.js